import React from 'react';
import classnames from 'classnames';
import { scaleToSize } from '../../_helpers';
import imageStyles from './Image.scss';
export const ImageContent = ({ width , height , file , alt , isPixel , canZoom , onZoom , withSrcSet =false  })=>{
    const size = scaleToSize(file, {
        width,
        height
    });
    return /*#__PURE__*/ React.createElement("img", {
        alt: alt,
        "aria-hidden": "true",
        className: classnames(imageStyles['image'], isPixel && imageStyles['pixel'], canZoom && imageStyles['zoomable']),
        src: file.src,
        srcSet: withSrcSet ? file.srcSet : '',
        style: size,
        onClick: canZoom ? onZoom : undefined
    });
};
ImageContent.displayName = 'ImageContent';
export default ImageContent;
